import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, TranslateModule],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.css',
})
export class ReportsComponent implements OnInit {
  botones: string[] = ['settings.buttons.prescription-broker'];
  botonSeleccionado = 0;
  opt = false;
  accountType: string | null = null;

  constructor(private authStateService: AuthStateService) {}

  ngOnInit(): void {
    this.accountType = this.authStateService.getAccountType();
    if (this.accountType === 'broker') {
      this.botones.push('reports.brokers');
    }
  }

  seleccionarBoton(index: number) {
    this.botonSeleccionado = index;
    this.opt = false;
  }

  changeOpt() {
    this.opt = !this.opt;
  }
}
